import cashierBonusTypes from "./cashierBonusTypes";
import { PENDING, SUCCESS, ERROR } from "../../globalStatuses/globalStatuses";

const initialState = {
    status: '',
    analytics: null,
    transactionsStatus: '',
    transactionsData: null,
}

const cashierBonusReducer = (state = initialState, action) => {
    switch (action.type) {
        case cashierBonusTypes.GET_CASHIER_BONUS_ANALYTICS_PENDING:
            return { ...state, status: PENDING }
        case cashierBonusTypes.GET_CASHIER_BONUS_ANALYTICS_SUCCESS:
            return { ...state, status: SUCCESS, analytics: action.payload }
        case cashierBonusTypes.GET_CASHIER_BONUS_ANALYTICS_ERROR:
            return { ...state, status: ERROR }
        case cashierBonusTypes.GET_CASHIER_TRANSACTIONS_PENDING:
            return { ...state, transactionsStatus: PENDING }
        case cashierBonusTypes.GET_CASHIER_TRANSACTIONS_SUCCESS:
            return { ...state, transactionsStatus: SUCCESS, transactionsData: action.payload }
        case cashierBonusTypes.GET_CASHIER_TRANSACTIONS_ERROR:
            return { ...state, transactionsStatus: ERROR }
        default:
            return state
    }
}

export default cashierBonusReducer;
